import React from 'react'
import { BillResponseData } from '../../types/Billings'
import DiscoFormBill from '../../components/Forms/DiscoBillForm'
import AirTimeForm from '../../components/Forms/AirTimeForm'
import PaidTvForm from '../../components/Forms/PaidTvForm'

interface UtilityFormsProps {
  selectedBiller: BillResponseData
}

const UtilityForms: React.FC<UtilityFormsProps> = ({selectedBiller}) => {
  return (
    <>
    {
      selectedBiller?.slug === 'ELECTRIC_DISCO' && (
        <DiscoFormBill selectedBiller={selectedBiller}/>
      )
    }
    {
      selectedBiller?.slug === 'AIRTIME_AND_DATA' && (
        <AirTimeForm selectedBiller={selectedBiller}/>
      )
    }
    {
      selectedBiller?.slug === 'PAY_TV' && (
        <PaidTvForm selectedBiller={selectedBiller}/>
      )
    }
    </>
  )
}

export default UtilityForms